
import { api_host,api_auth} from '../../common/globals/constants';

export const getDetalleDisponibilidadConsolidadaCustom = (user, objetivo_id, node, fecha_inicio, fecha_termino, token, schedule) => 
fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadConsolidadaCustom/?user=${user}&key=${api_auth}&horarioId=${schedule}&objetivoId=${objetivo_id}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&token=${token}&nodoId=${node}`)
